import { createRouter, createWebHistory } from 'vue-router'

import HomeView from '@/views/HomeView.vue'
import NotFoundView from '@/views/NotFoundView.vue'

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{ path: '/', name: 'Home', component: HomeView },
		{ path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFoundView },
	],

	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) return savedPosition

		if (to.hash) {
			const el = document.querySelector(to.hash)
			if (el) {
				return window.scrollTo({
					top: el.getBoundingClientRect().top + window.scrollY,
					behavior: 'smooth',
				})
			}
		}

		return { top: 0 }
	}


})

export default router
